import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "spacing"
    }}>{`Spacing`}</h1>
    <p>{`Our spacing unit is derived from our 4px baseline grid.`}</p>
    <p><img alt="Baseline grid image" src={require("./img/spacing-1.svg")} /></p>
    <p>{`Any kind of spacing value, be it margin or padding, should be in multiples of 4(px).`}</p>
    <p><img alt="Spacing scale" src={require("./img/spacing-3.svg")} /></p>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <p>{`Here's an example of a card structure which fits well with our spacing guidelines.
`}<img alt="Example of a card structure" src={require("./img/spacing-4.svg")} /></p>
    <p>{`Additional UI elements, using our spacing guidelines`}</p>
    <p><img alt="Example of smaller UI elements" src={require("./img/spacing-5.svg")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      